import { render, staticRenderFns } from "./SubmitLoader.vue?vue&type=template&id=5f2135d5&"
import script from "./SubmitLoader.vue?vue&type=script&lang=js&"
export * from "./SubmitLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports